var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"super-icon",class:_vm.icon}),_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.action && _vm.actionText)?_c('router-link',{attrs:{"to":_vm.action},on:{"click":_vm.action}},[_vm._v(_vm._s(_vm.actionText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }